import styled from 'styled-components'

export const Container = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin: auto;
	height: 70vh;
	width: 100%;
`
